import styled from 'styled-components';
import {
  SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_600,
} from '@oneaudi/unified-web-common';
import { Text } from '@oneaudi/unified-web-components';

export const SwitchNCUCWrapper = styled.div`
  padding-bottom: ${SYS_SPACE_FIXED_600};
`;

export const SwitchButtons = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: ${SYS_SPACE_FIXED_100};
}
`;

export const SubHeadText = styled(Text)`
  color: ${SEM_COLOR_FORMS_FOREGROUND_TEXT_CAPTION_LIGHT};
`;
